import Vue from 'vue';
import {indexOf, map} from 'lodash';
import {
    createFloorPlan,
    updateFloorPlan,
    removeFloorPlan,
    createFloorPlanRoom,
    updateFloorPlanRoom,
    removeFloorPlanRoom
} from '../../api/unit.api';

export const getters = {
    floorPlans:        (state) => state.floorPlans,
    loadFloorPlanById: (state, getters) => (floorPlanId) => {
        return new Promise((resolve) => resolve(getters.floorPlans.find((floorPlan) => floorPlan.id === floorPlanId) || null));
    },
}

export const actions = {
    async createFloorPlan({ commit }, data) {
        return createFloorPlan(data).then((data) => commit('ADD_FLOOR_PLAN', data))
    },
    async updateFloorPlan({ commit }, data) {
        return updateFloorPlan(data).then((data) => commit('UPDATE_FLOOR_PLAN', data))
    },
    async removeFloorPlan({ commit }, floorPlanId) {
        return removeFloorPlan(floorPlanId).then((id) => commit('REMOVE_FLOOR_PLAN', id))
    },

    async createFloorPlanRoom({ commit }, data) {
        const { floorPlanId } = data;
        return createFloorPlanRoom(data).then((data) => commit('ADD_FLOOR_PLAN_ROOM', { ...data, floorPlanId }))
    },
    async updateFloorPlanRoom({ commit }, data) {
        const { floorPlanId } = data;
        return updateFloorPlanRoom(data).then((data) => commit('UPDATE_FLOOR_PLAN_ROOM', { ...data, floorPlanId }))
    },
    async removeFloorPlanRoom({ commit }, ids) {
        return removeFloorPlanRoom(ids).then((ids) => commit('REMOVE_FLOOR_PLAN_ROOM', ids))
    },
}

export const mutations = {
    SET_FOOR_PLANS:    (state, floorPlansData) => state.floorPlans = floorPlansData,
    ADD_FLOOR_PLAN:    (state, floorPlanData) => state.floorPlans.push(floorPlanData),
    UPDATE_FLOOR_PLAN: (state, floorPlanData) => {
        const index = indexOf(map(state.floorPlans, (object) => object.id), floorPlanData.id);
        Vue.set(state.floorPlans, index, floorPlanData);
    },
    REMOVE_FLOOR_PLAN: (state, floorPlanId) => {
        const index = indexOf(map(state.floorPlans, (object) => object.id), floorPlanId);
        if (index !== -1) {
            state.floorPlans.splice(index, 1);
        }
    },

    ADD_FLOOR_PLAN_ROOM:    (state, data) => {
        const { floorPlanId } = data;
        const index = indexOf(map(state.floorPlans, (object) => object.id), floorPlanId);
        if (index !== -1) {
            const floorPlan = state.floorPlans[index];
            delete data.floorPlanId;
            floorPlan.rooms.push(data);
            Vue.set(state.floorPlans, index, floorPlan);
        }
    },
    UPDATE_FLOOR_PLAN_ROOM: (state, data) => {
        const { floorPlanId, id } = data;
        const index = indexOf(map(state.floorPlans, (object) => object.id), floorPlanId);
        if (index !== -1) {
            const floorPlan = state.floorPlans[index];
            const roomIndex = indexOf(map(floorPlan.rooms, (object) => object.id), id);
            if (roomIndex !== -1) {
                delete data.floorPlanId;
                Vue.set(state.floorPlans[index].rooms, roomIndex, data);
            }
        }
    },
    REMOVE_FLOOR_PLAN_ROOM: (state, ids) => {
        const { id, floorPlanId } = ids;
        const index = indexOf(map(state.floorPlans, (object) => object.id), floorPlanId);
        if (index !== -1) {
            const floorPlan = state.floorPlans[index];
            const roomIndex = indexOf(map(floorPlan.rooms, (object) => object.id), id);
            if (roomIndex !== -1) {
                floorPlan.rooms.splice(roomIndex, 1);
            }
        }
    },
}
